<template>
  <div class="running">
    <div style="margin-bottom:0.8rem">
      <el-button @click="addRun" size="small" type="success" icon="el-icon-plus">添加记录</el-button>
    </div>
    <div v-for="(msg,ide) in runDate" :key="ide" class="run-code-box">
      <el-row>
        <el-col :span="12">
          <span class="trend-title1">基本信息</span>
          <div class="run-code">
            <span class="trend-title">设备名称</span>
            <el-input type="text" placeholder="请输入" v-model="msg.devName	"></el-input>
          </div>
          <div class="run-code">
            <span class="trend-title">运行状态</span>
            <el-select v-model="msg.devStatus" placeholder="请选择">
              <el-option
                v-for="item in thingType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="run-code">
            <span class="trend-title">启动时间</span>
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="msg.startTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
          <div class="run-code">
            <span class="trend-title">运行时长</span>
            <el-input type="number" placeholder="请输入" v-model="msg.runTime">
              <template slot="suffix">天</template>
            </el-input>
          </div>
          <div class="run-code">
            <span class="trend-title">保养周期</span>
            <el-input type="number" placeholder="请输入" v-model="msg.cycle">
              <template slot="suffix">日/次</template>
            </el-input>
          </div>
          <div class="run-code">
            <span class="trend-title">下次保养日</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="msg.nextMaintain"
              type="date"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
          <div class="run-code">
            <span class="trend-title">负责人</span>
            <el-input type="text" placeholder="请输入" v-model="msg.charge"></el-input>
          </div>
          <div class="run-code">
            <span class="trend-title">设备照片</span>
            <div style="display:inline-block; vertical-align:top;">
              <el-upload 
                class="avatar-uploader"  
                :http-request="(e)=>{uploadfile(e,ide)}" 
                action="#" 
                :before-upload="beforeAvatarUpload"
                :show-file-list="false">
                <img v-if="msg.imgs" :src="msg.imgs" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="padding-left:1rem; padding-right:1rem; overflow-y:auto">
          <span class="trend-title1">运行记录</span>
          <div class="run-flex-box title">
            <div>时间</div>
            <div>运行速度</div>
            <!-- <el-button @click="addTimeRun(ide)" size="small" type="success" icon="el-icon-plus"></el-button> -->
            <i @click="addTimeRun(ide)" class="el-icon el-icon-circle-plus-outline f_green"></i>
          </div>
          <div v-for="(item,index) in msg.records" :key="index" class="run-flex-box">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="item.startTime"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
              <el-input type="number" placeholder="请输入" v-model="item.speed"></el-input>
              <!-- <el-button @click="removeTimeRun(ide,item.id,index)" size="small" type="danger" icon="el-icon-minus"></el-button>             -->
              <i @click="removeTimeRun(ide,item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
          </div>
        </el-col>
      </el-row>
      <el-button @click="removeRun(msg.id,ide)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
    </div>
    <div class="last-save">
      <el-button :loading="runLoading" @click="saveRun" size="small" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/device/device'
import upapi from '@/apis/upload'
export default {
  data(){
    return{
      runLoading:false,//加载状态
      thingType: [
        {
          value: 1,
          label: '关机状态'
        }, 
        {
          value: 2,
          label: '检修状态'
        },
        {
          value: 3,
          label: '低速运转'
        },
        {
          value: 4,
          label: '正常运转'
        },
        {
          value: 5,
          label: '高速运转'
        },
      ],

      runDate:[
        {
          devName	:'',
          devStatus:'',
          startTime:'',
          runTime:'',
          cycle:'',
          imgs:'',
          nextMaintain:'',
          charge:'',
          records:[
            {startTime:'',speed:''}
          ]
        }
      ],
    }
  },
  mounted(){
    this.getRun()
  },
  methods:{
    //保存运行记录
    saveRun(){
      this.runLoading = true;
      api.saveRecord(this.runDate).then(res=>{
        if(res.code==10000){
          this.getRun()
          this.$message.success('保存成功');
          this.runLoading = false;
        }else{
          this.runLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据
    getRun(){
      api.getRecord({
        params:{
          limit:100
        }
      }).then(res=>{
        if(res.code==10000){
          if(res.data){
            this.runDate = res.data
          }
        }
      })
    },
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.runDate[i].imgs = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //删除一行运行数据
    removeRun(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delRecord([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getRun()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.runDate.splice(index,1)
      }
    },
    //删除一行运行记录
    removeTimeRun(_id,index,ind){
      for(var i in this.runDate){
        if(i==_id){
          if(index){
            this.$confirm('确认删除, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              api.delRecordList([index]).then(res=>{
                if(res.code==10000){
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  this.getRun()
                }else{
                  this.$message.error(res.message);
                  return;
                }
              })
            })
          }else{
            this.runDate[i].records.splice(ind,1)
          }
        }
      } 
    },
    //添加一行运行数据
    addRun(){
      this.runDate.push({          
        devName	:'',
        devStatus:'',
        startTime:'',
        runTime:'',
        cycle:'',
        imgs:'',
        nextMaintain:'',
        charge:'',
        records:[
          {startTime:'',speed:''}
        ]
      })
    },
    //添加一行运行记录
    addTimeRun(_id){
      console.log(this.runDate);
      for(var i in this.runDate){
        if(i==_id){
          if(this.runDate[i].records){
            this.runDate[i].records.push({          
              startTime:'',speed:'' 
            })
          }else{
            this.runDate[i].records = []
            this.runDate[i].records.push({          
              startTime:'',speed:'' 
            })
          }
        }
      }
    },
  }
}
</script>
<style lang="less" scoped>
.running{
  .trend-title1{ font-weight: bold; color: #24ffb1; font-size: .9rem; padding-left: 10px; border-left: #24ffb1 solid 5px; display: inline-block; margin: .4rem 0 .6rem;}
  .run-code{ display: flex; flex-direction: row;
    .el-input,.el-select{ flex: 1;}
  }
  .run-code-box{ display:inline-block; position: relative; width: 45%; padding:.5rem 0 1rem 1rem; margin-right:1rem; margin-bottom: 1rem; 
    border: #3570ff solid 1px; height: 23rem; overflow:hidden;
    .el-row,.el-col{ height: 100%; overflow:hidden;}
    .run-flex-box{ display: flex; flex-direction: row;
      &>div:nth-child(1){ flex: 1;}
      &>div:nth-child(2){ width: 7rem;}
      i{ font-size: 1rem; line-height: 1.8rem; margin-left: .6rem;}
    }
    .run-flex-box.title{
      &>div{ font-size: .8rem; line-height: 1.8rem; background: #3570ff; text-align: center;}
      &>div:first-child{ border-right: #042097 solid 1px;}
    }
    .el-button.el-button--danger{ position: absolute; bottom: 1rem; left: 1rem;}
  }
}
</style>